/**
 * Contenta-Modul
 * 
 * Attila Németh, UBG
 * 19.03.2019
 */
 
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
  ],
  exports: [
  ],
  entryComponents: [
  ],
})
export class UbgContentaModule {

  constructor() {}

}

